export enum FeatureFlagsEnum {
    FF_Notifications = 'FF_Notifications',
    FF_MrktplcSellers_2_8 = 'FF_MrktplcSellers_2_8',
    FF_MrktplcBuyers_3_6 = 'FF_MrktplcBuyers_3_6',
    FF_MrktplcBuyers_3_7 = 'FF_MrktplcBuyers_3_7',
    FF_MrktplcBuyers_3_8 = 'FF_MrktplcBuyers_3_8',
    FF_MrktplcSellers_2_13 = 'FF_MrktplcSellers_2_13',
    FF_MrktplcBuyers_3_13 = 'FF_MrktplcBuyers_3_13',
    FF_MrktplcSellers_2_14 = 'FF_MrktplcSellers_2_14',
    FF_MrktplcSellers_2_15 = 'FF_MrktplcSellers_2_15',
    FF_DevAuditLogs = 'FF_DevAuditLogs',
    FF_DangerousMaintenanceOperations = 'FF_DangerousMaintenanceOperations',
}
